import {
  AgentMessage,
  MessageContext,
} from '~/features/ask-anything/agentic-ai/types';
import { sylvanus } from '~/services/serviceInstances';

import {
  AgentExecutionMessage,
  MessageContext2,
} from '../../types/sylvanus/agentExecution';
import { mapServerAgentExecutionMessageToAgentExecutionMessage } from './transformers';

type Request = {
  agentExecutionId: string;
  message: string;
  context: MessageContext;
  metadata?: Record<string, string>;
};

export const sendAgentExecutionMessage = async ({
  agentExecutionId,
  metadata,
  message,
  context,
}: Request): Promise<AgentMessage> => {
  const response = await sylvanus.post<AgentExecutionMessage>(
    `/agent-execution/${agentExecutionId}/message`,
    {
      message,
      context: mapMessageContextToMessageContext2(context),
      metadata,
    },
  );

  return mapServerAgentExecutionMessageToAgentExecutionMessage(response);
};

const mapMessageContextToMessageContext2 = (
  context: MessageContext,
): MessageContext2 => {
  return {
    search_query: context.searchQuery,
    search_entity: context.searchEntity,
    selected_ids: context.selectedIds,
    entities_in_view: context.entitiesInView,
    message_type: context.messageType,
  };
};
